import * as React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"

type ExternalLinkType = {
  children: React.ReactNode
  href: string
}

const ExternalLink = ({ children, href }: ExternalLinkType) => (
  <OutboundLink
    className="inline-link"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </OutboundLink>
)

export default ExternalLink
